import formattedDate from "../../shared/utils/formatted-date";

const initialState = {
    blocked: false,
    startDate: formattedDate(new Date().getTime()),
    endDate: formattedDate(new Date().getTime() + 86399999)
}

export const ALL_FORMS_ACTION_TYPE = {
    SET_BLOCKED: 'SET_BLOCKED',
    SET_END_DATE: 'SET_END_DATE',
    SET_START_DATE: 'SET_START_DATE'
}

const allFormsReducer = (state = initialState, action) => {
    switch (action.type) {
        case (ALL_FORMS_ACTION_TYPE.SET_BLOCKED):
            return {
                ...state,
                blocked: action.payload
            }
        case (ALL_FORMS_ACTION_TYPE.SET_START_DATE):
            return {
                ...state,
                startDate: action.payload
            }
        case (ALL_FORMS_ACTION_TYPE.SET_END_DATE):
            return {
                ...state,
                endDate: action.payload
            }
        default:
            return state
    }
}

export default allFormsReducer